import React, { FC } from "react";
import { BoxProps, Divider } from "theme-ui";

// Extend with {prop:string}&BoxProps if added properties will be added
type DividerHorizontalType = BoxProps;
export const DividerHorizontal: FC<DividerHorizontalType> = ({
  children,
  ...props
}: DividerHorizontalType) => (
  <Divider variant="boxes.dividers.horizontal" {...props} sx={{ my: 0 }}>
    {children}
  </Divider>
);
